import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const ArrowButton = styled.button`
  background: none;
  cursor: pointer;

  svg {
    height: 18px;
    width: 18px;
  }

  &:disabled {
    cursor: not-allowed;

    svg {
      color: ${({ theme }) => theme.neutral_300};
    }
  }
`;

export const PageNumberButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  background-color: transparent;
  cursor: pointer;

  ${({ $active, theme }) =>
    $active &&
    `background-color: ${theme.neutral_700}; color: ${theme.neutral_100};`}
`;
